import I18n from 'lib/i18n'

import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'rc-tooltip'
import nearMe from './assets/near_me.svg'

const GeolocateButton = ({
  onClick: handleGeolocate,
  isGeolocating,
  withMap,
  fullScreenFiltersPage,
  locationFilterComponent
}) => {
  if (fullScreenFiltersPage && locationFilterComponent) {
    return (
      <div className='near-me-container'>
        <img src={nearMe} width='30' height='19' alt='Near me' />
        <a href='#' onClick={handleGeolocate}>
          {I18n.t('search.filters.near_me')}
        </a>
      </div>
    )
  }

  return (
    <Tooltip placement='left' trigger={['hover']} overlay={<span>{I18n.t('react.search.geolocation.tooltip')}</span>}>
      <span
        className={`map-button map-geolocate-button ${withMap ? '' : 'without-map'} ${
          isGeolocating ? ' geolocating' : ''
        }`}
        onClick={handleGeolocate}
      />
    </Tooltip>
  )
}

GeolocateButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isGeolocating: PropTypes.bool,
  withMap: PropTypes.bool,
  fullScreenFiltersPage: PropTypes.bool,
  locationFilterComponent: PropTypes.bool
}

export default GeolocateButton
